const CopyInput = ({ text, hideText, hideInput, floated }) => {
  return (
    <div className={classNames({ 'input-group width-100': !floated, 'pull-left mr-8': floated })}>
      <input
        type="text"
        readOnly
        value={text}
        className={classNames('form-control input-sm as-normal', { hidden: hideInput })}
      />
      <a
        className={classNames('clipboard pointer-cursor', {
          'input-group-addon': !hideInput,
          'btn btn-default': hideInput
        })}
        data-clipboard-text={text}
        data-success={I18n.t('copied')}
        data-error={I18n.t('press-ctrl-c')}
      >
        <small>
          <i className={classNames('fa-light fa-clone', { 'mr-8': !hideText })} title={I18n.t('copy')}></i>
          {!hideText && I18n.t('copy')}
        </small>
      </a>
    </div>
  )
}

export default CopyInput
